export enum ECardItems {
  Search = 'search',
  Recommendations = 'recommendations',
  Updates = 'updates',
  Comparison = 'comparison',
  Selection = 'selection',
}

export const cardItems = [
  {
    name: ECardItems.Search,
    title: 'Удобный поиск',
    subtitle: 'Десятки фильтров и\u00A0результаты на\u00A0карте',
    className: 'search',
  },
  {
    name: ECardItems.Recommendations,
    title: 'Персональные рекомендации у\u00A0вас\u00A0в\u00A0кармане',
    subtitle: 'Лучшие объявления от\u00A0умного помощника',
    className: 'recommendations',
  },
  {
    name: ECardItems.Updates,
    title: 'Вы в\u00A0курсе самых важных обновлений',
    subtitle: 'Чаты, изменение цен и\u00A0другие события',
    className: 'updates',
  },
  {
    name: ECardItems.Comparison,
    title: 'Проще сравнивать объявления ',
    subtitle: 'Посмотрите на\u00A0важные отличия или\u00A0на\u00A0все\u00A0параметры сразу',
    className: 'comparison',
  },
  {
    name: ECardItems.Selection,
    title: 'Легко делиться подборками',
    subtitle: 'Когда ищете вместе с\u00A0близкими, будет проще обсуждать варианты',
    className: 'selection',
  },
];
